import { useEffect, useRef } from 'react';
import { useLoggerService } from '../logging';
import { ChallengeOptions } from './captchaService';
import { useCaptchaService } from './CaptchaServiceContext';

export const CaptchaChallenge = ({ onSuccess, onError, challengeLabel }: ChallengeOptions) => {
    const captchaService = useCaptchaService();
    const loggerService = useLoggerService();

    const elementRef = useRef<HTMLDivElement>(null);
    const widgetId = useRef<string | undefined | null>('');

    useEffect(() => {
        const createChallenge = async () => {
            if (!elementRef.current || widgetId.current) {
                return;
            }

            if (!captchaService.isInitialized()) {
                await captchaService.initialize();
            }

            widgetId.current = captchaService.createChallenge(elementRef.current, {
                onSuccess,
                onError: (error) => {
                    if (error) {
                        // 30003X: Client Execution Error.
                        if (error === '300030' || error === '300031') {
                            loggerService.info('captcha-error', 'bot activity blocked');
                        } else {
                            loggerService.error('captcha-error', error instanceof Error ? error.message : error, error);
                        }
                        onError?.(error);
                    }
                },
                challengeLabel,
            });
        };

        void createChallenge();
    }, [captchaService, widgetId, elementRef, onSuccess, challengeLabel, loggerService, onError]);

    /**
     * "font-size: 0" ensures the div have 0 height when captcha is invisible.
     * It has no effect on visible captcha.
     */
    return <div style={{ fontSize: 0 }} ref={elementRef} />;
};
